export const getSelectedIndex = (steps, selectedStep) => steps.findIndex(({ id }) => id === selectedStep);

export const isLastStep = (steps, index) => steps.length - 1 === index;
